// Arqum 2026-10-16.
(function () {
const modules = {
"capture-summary.mjs": function (exports, load) {
// Arqum 2026-10-16.
const SHOP = 'wdpa1m-fi.myshopify.com';
const GOOGLE_ATTRIBUTE = '__ips_ads_capture_v1';
const META_ATTRIBUTE = '__ips_meta_ad_capture_v1';
const JOURNAL_ATTRIBUTE = '__ips_ad_tracking_journal_v1';
const SUMMARY_ATTRIBUTE = '__IPS ad tracking';
const MAX_ENTRIES = 10;
const MAX_AGE = 30 * 24 * 60 * 60 * 1000;
const MAX_SUMMARY_LENGTH = 2800;
const numeric = value => typeof value === 'string' && /^[1-9]\d{0,22}$/.test(value);
const bindingValid = value => typeof value === 'string' && /^[a-f0-9]{64}$/.test(value);
const captureIdValid = value => typeof value === 'string' && /^[A-Za-z0-9_-]{1,80}$/.test(value);
const timeValid = (value, now) => Number.isSafeInteger(value) && value > 0 && value <= now && now - value < MAX_AGE;
const object = value => value !== null && typeof value === 'object' && !Array.isArray(value);

function captureAllowed(privacy, policy = {}) {
  const regionalReviewed = policy.regionalProcessingReviewed === true &&
    typeof policy.regionalPolicyReviewReference === 'string' && policy.regionalPolicyReviewReference.trim().length >= 8;
  return privacy?.marketingAllowed === true && privacy?.saleOfDataAllowed === true &&
    (privacy.marketingChoice === 'yes' || (regionalReviewed && privacy.marketingChoice === '')) &&
    ['', 'yes'].includes(privacy.saleChoice);
}

function projectAd(ad) {
  if (!object(ad) || ad.platform !== 'Meta' || !numeric(ad.adId) || !numeric(ad.campaignId) || !numeric(ad.adsetId)) return null;
  return { platform: 'Meta', adId: ad.adId, campaignId: ad.campaignId, adsetId: ad.adsetId };
}

function projectGooglePlacement(value) {
  if (!object(value) || !numeric(value.adId) || !numeric(value.campaignId) || !numeric(value.adGroupId)) return null;
  return { adId: value.adId, campaignId: value.campaignId, adGroupId: value.adGroupId };
}

function googlePlacementFromLanding(search) {
  if (typeof search !== 'string' || search.length > 8192) return null;
  const params = new URLSearchParams(search);
  const source = params.getAll('utm_source');
  const medium = params.getAll('utm_medium');
  if (source.length !== 1 || medium.length !== 1 || source[0].trim().toLowerCase() !== 'google' ||
      medium[0].trim().toLowerCase() !== 'cpc') return null;
  function identifier(names) {
    if (names.some(name => params.getAll(name).length > 1)) return null;
    const values = names.flatMap(name => params.getAll(name));
    if (!values.length || values.some(value => !numeric(value)) || new Set(values).size !== 1) return null;
    return values[0];
  }
  return projectGooglePlacement({ adId: identifier(['utm_content']), campaignId: identifier(['utm_id']),
    adGroupId: identifier(['adgroupid', 'adgroup_id']) });
}

function validStoredCandidate(raw, attribute, cart, now) {
  if (!object(raw) || raw.version !== 1 || raw.shop !== SHOP || typeof raw.cartHadItems !== 'boolean' ||
      !bindingValid(raw.cartBinding) || raw.cartBinding !== cart?.binding ||
      raw.cartHadItems !== (cart.itemCount > 0)) return null;
  const touch = raw.touch;
  if (!object(touch) || touch.shop !== SHOP || !captureIdValid(touch.captureId) || !timeValid(touch.capturedAt, now)) return null;
  const base = { captureId: touch.captureId, capturedAt: touch.capturedAt };
  if (attribute === META_ATTRIBUTE) {
    const ad = projectAd(touch.ad);
    if (!ad || typeof touch.qa !== 'boolean') return null;
    return { ...base, source: 'Meta', ad, qa: touch.qa };
  }
  if (attribute !== GOOGLE_ATTRIBUTE || !object(touch.click) || !['gclid', 'gbraid', 'wbraid'].includes(touch.click.kind) ||
      typeof touch.click.value !== 'string' || !touch.click.value.length || touch.click.value.length > 512 ||
      /[\s\x00-\x1f\x7f]/.test(touch.click.value)) return null;
  return { ...base, source: 'Google', clickType: touch.click.kind,
    qa: /ips[_-]?qa/i.test(touch.click.value) || /ips[_-]?qa/i.test(touch.captureId) };
}

function validateEnvelope(text, stored, attribute, candidate, cart, now, policy = {}) {
  if (!candidate || typeof text !== 'string' || !text.length || text.length > 4096) return null;
  let envelope;
  try { envelope = JSON.parse(text); } catch { return null; }
  if (!object(envelope) || envelope.version !== 1 || envelope.shop !== SHOP || envelope.exportReady !== false ||
      envelope.captureId !== candidate.captureId || envelope.capturedAt !== candidate.capturedAt ||
      envelope.cartBinding !== cart.binding || !Number.isSafeInteger(envelope.consentObservedAt) ||
      envelope.consentObservedAt < envelope.capturedAt || envelope.consentObservedAt > now ||
      !captureAllowed(envelope.consent, policy)) return null;
  const explicit = envelope.consent.marketingChoice === 'yes';
  if (envelope.permissionBasis !== (explicit ? 'explicit_marketing_choice' : 'shopify_processing_permissions') ||
      (!explicit && envelope.regionalPolicyReviewReference !== policy.regionalPolicyReviewReference)) return null;
  if (attribute === META_ATTRIBUTE) {
    const ad = projectAd(envelope.ad);
    if (envelope.source !== 'client_meta_ad_capture_candidate' || envelope.qa !== candidate.qa || !ad ||
        JSON.stringify(ad) !== JSON.stringify(candidate.ad)) return null;
  } else if (attribute === GOOGLE_ATTRIBUTE) {
    if (envelope.source !== 'client_capture_candidate' || envelope.click?.kind !== stored.touch.click.kind ||
        envelope.click?.value !== stored.touch.click.value) return null;
  } else return null;
  return { ...candidate, permissionBasis: explicit ? 'explicit_marketing_choice' : 'shopify_processing_permissions' };
}

function projectEntry(raw, now) {
  if (!object(raw) || !captureIdValid(raw.captureId) || !timeValid(raw.capturedAt, now) ||
      !['explicit_marketing_choice', 'shopify_processing_permissions'].includes(raw.permissionBasis)) return null;
  const base = { source: raw.source, captureId: raw.captureId, capturedAt: raw.capturedAt,
    permissionBasis: raw.permissionBasis };
  if (raw.source === 'Meta') {
    const ad = projectAd(raw.ad);
    return ad ? { ...base, ad } : null;
  }
  if (raw.source === 'Google' && ['gclid', 'gbraid', 'wbraid'].includes(raw.clickType) &&
      bindingValid(raw.clickHash) && !/ips[_-]?qa/i.test(raw.captureId)) {
    const placement = raw.placement === undefined ? undefined : projectGooglePlacement(raw.placement);
    if (placement === null) return null;
    return { ...base, clickType: raw.clickType, clickHash: raw.clickHash, ...(placement ? { placement } : {}) };
  }
  return null;
}

function readJournal(raw, cart, now) {
  if (!object(raw) || raw.version !== 1 || raw.shop !== SHOP || !bindingValid(raw.cartBinding) ||
      raw.cartBinding !== cart?.binding || typeof raw.cartHadItems !== 'boolean' ||
      (raw.cartHadItems === true && cart.itemCount === 0) ||
      !Array.isArray(raw.entries) || raw.entries.length > MAX_ENTRIES ||
      !Number.isSafeInteger(raw.overflowCount) || raw.overflowCount < 0 || raw.overflowCount > 1000000) return null;
  const entries = [];
  const seen = new Set();
  let previousTime = 0;
  for (const entry of raw.entries) {
    if (Number.isSafeInteger(entry?.capturedAt) && entry.capturedAt > 0 && now - entry.capturedAt >= MAX_AGE) continue;
    const clean = projectEntry(entry, now);
    const key = clean ? clean.source + ':' + clean.captureId : '';
    if (!clean || clean.capturedAt < previousTime || seen.has(key)) return null;
    seen.add(key);
    previousTime = clean.capturedAt;
    entries.push(clean);
  }
  if (!entries.length) return null;
  return { version: 1, shop: SHOP, cartBinding: cart.binding, cartHadItems: cart.itemCount > 0,
    entries, overflowCount: raw.overflowCount };
}

function appendCapture(journal, capture, cart, context, now) {
  if (!capture || capture.qa === true || context?.freshArrival !== true || capture.captureId !== context.captureId ||
      capture.capturedAt !== context.now || !timeValid(context.now, now)) return journal;
  const entry = projectEntry(capture, now);
  if (!entry) return journal;
  if (entry.source === 'Google') {
    const placement = googlePlacementFromLanding(context.search);
    if (placement) entry.placement = placement;
  }
  const next = journal ? structuredClone(journal) : { version: 1, shop: SHOP, cartBinding: cart.binding,
    cartHadItems: cart.itemCount > 0, entries: [], overflowCount: 0 };
  if (next.entries.some(row => row.source === entry.source && row.captureId === entry.captureId)) return journal;
  if (next.entries.length && entry.capturedAt < next.entries.at(-1).capturedAt) return journal;
  next.entries.push(entry);
  if (next.entries.length > MAX_ENTRIES) {
    next.entries.shift();
    next.overflowCount = Math.min(1000000, next.overflowCount + 1);
  }
  return next;
}

function sast(value) {
  return new Date(value + 2 * 60 * 60 * 1000).toISOString().slice(0, 19).replace('T', ' ') + ' SAST';
}

function formatSummary(journal) {
  if (!journal?.entries?.length) return '';
  const rows = ['Captured ad references', 'incomplete history', 'no purchase credit'];
  journal.entries.forEach((entry, index) => {
    const fields = [`${index + 1} - ${entry.source} ad ${entry.source === 'Meta' ? entry.ad.adId : entry.placement?.adId || 'unresolved'}`];
    if (entry.source === 'Meta') fields.push(`campaign ${entry.ad.campaignId}`, `adset ${entry.ad.adsetId}`);
    else {
      if (entry.placement) fields.push(`campaign ${entry.placement.campaignId}`, `ad group ${entry.placement.adGroupId}`);
      fields.push(`click type ${entry.clickType}`);
    }
    fields.push(`captured ${sast(entry.capturedAt)}`, entry.permissionBasis === 'explicit_marketing_choice' ?
      'permission explicit choice' : 'permission Shopify native permissions');
    rows.push(fields.join(', '));
  });
  if (journal.overflowCount) rows.push(`Earlier captures omitted by limit ${journal.overflowCount}`);
  const result = rows.join(', ');
  if (result.length > MAX_SUMMARY_LENGTH) throw new Error('summary_length_exceeded');
  return result;
}

Object.assign(exports, { SHOP, GOOGLE_ATTRIBUTE, META_ATTRIBUTE, JOURNAL_ATTRIBUTE, SUMMARY_ATTRIBUTE, MAX_ENTRIES, MAX_AGE, MAX_SUMMARY_LENGTH, captureAllowed, googlePlacementFromLanding, validStoredCandidate, validateEnvelope, readJournal, appendCapture, formatSummary });

},
"summary-writer.mjs": function (exports, load) {
// Arqum 2026-10-16.
const { SHOP, GOOGLE_ATTRIBUTE, META_ATTRIBUTE, JOURNAL_ATTRIBUTE, SUMMARY_ATTRIBUTE,
  captureAllowed, validStoredCandidate, validateEnvelope, readJournal, appendCapture, formatSummary } = load('capture-summary.mjs');
const WRITE_LOCK_NAME = `ips-ad-summary-write:${SHOP}:v1`;
const SOURCE_ATTRIBUTES = [GOOGLE_ATTRIBUTE, META_ATTRIBUTE];
const OWNED_ATTRIBUTES = [...SOURCE_ATTRIBUTES, JOURNAL_ATTRIBUTE, SUMMARY_ATTRIBUTE];

function readPrivacy(env) {
  try {
    const api = env.Shopify.customerPrivacy;
    const choices = api.currentVisitorConsent();
    return { marketingAllowed: api.marketingAllowed() === true, saleOfDataAllowed: api.saleOfDataAllowed() === true,
      marketingChoice: choices.marketing, saleChoice: choices.sale_of_data };
  } catch { return {}; }
}

function stored(env, key, limit = 4096) {
  try {
    const text = env.localStorage.getItem(key);
    if (!text || text.length > limit) return null;
    return JSON.parse(text);
  } catch { return null; }
}

function remove(env, key) {
  try { env.localStorage.removeItem(key); } catch {}
}

async function cartIdentity(env, request) {
  const raw = await request('cart.js', {}, true);
  if (!Number.isInteger(raw.item_count) || raw.item_count < 0 || typeof raw.token !== 'string' ||
      !raw.token.length || raw.token.length > 2048) throw new Error('cart_identity_unknown');
  const digest = await env.crypto.subtle.digest('SHA-256', new TextEncoder().encode(SHOP + ':' + raw.token));
  return { itemCount: raw.item_count, binding: Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('') };
}

function createCaptureSummaryWriter(env, config, attribute, request) {
  if (!SOURCE_ATTRIBUTES.includes(attribute)) throw new Error('unexpected_capture_source');
  async function post(attributes) {
    if (Object.keys(attributes).some(key => !OWNED_ATTRIBUTES.includes(key)) ||
        Object.values(attributes).some(value => typeof value !== 'string')) throw new Error('unexpected_cart_fields');
    await request('cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes }) });
  }
  async function clearAll() {
    for (const key of [...SOURCE_ATTRIBUTES, JOURNAL_ATTRIBUTE]) remove(env, key);
    await post(Object.fromEntries(OWNED_ATTRIBUTES.map(key => [key, ''])));
  }
  async function work(text, context) {
    if (!captureAllowed(readPrivacy(env), config)) { await clearAll(); return; }
    let cart;
    try { cart = await cartIdentity(env, request); }
    catch {
      remove(env, JOURNAL_ATTRIBUTE);
      await post({ [attribute]: '', [JOURNAL_ATTRIBUTE]: '', [SUMMARY_ATTRIBUTE]: '' });
      return;
    }
    if (!captureAllowed(readPrivacy(env), config)) { await clearAll(); return; }
    const now = Date.now();
    const current = stored(env, attribute);
    const otherAttribute = SOURCE_ATTRIBUTES.find(key => key !== attribute);
    const other = stored(env, otherAttribute);
    const oldJournal = stored(env, JOURNAL_ATTRIBUTE, 8192);
    const changedSharedCart = oldJournal?.cartBinding && oldJournal.cartBinding !== cart.binding;
    const invalidated = cart.itemCount === 0 && (oldJournal?.cartHadItems === true ||
      current?.cartHadItems === true || other?.cartHadItems === true);
    let journal = readJournal(oldJournal, cart, now);
    if (['cart_cleared', 'accelerated_checkout'].includes(context.kind)) journal = null;
    const attributes = {};
    if (changedSharedCart || invalidated) {
      journal = null;
      remove(env, JOURNAL_ATTRIBUTE);
      for (const key of SOURCE_ATTRIBUTES) {
        const source = key === attribute ? current : other;
        if ((invalidated && source?.cartHadItems === true) || (source?.cartBinding && source.cartBinding !== cart.binding)) {
          remove(env, key);
          attributes[key] = '';
        }
      }
    }
    const candidate = validStoredCandidate(stored(env, attribute), attribute, cart, now);
    let capture = validateEnvelope(text, stored(env, attribute), attribute, candidate, cart, now, config);
    if (!text && cart.itemCount === 0 && candidate) {
      capture = { ...candidate, permissionBasis: readPrivacy(env).marketingChoice === 'yes' ?
        'explicit_marketing_choice' : 'shopify_processing_permissions' };
    }
    if (capture?.source === 'Google' && capture.qa !== true) {
      const digest = await env.crypto.subtle.digest('SHA-256', new TextEncoder().encode(stored(env, attribute).touch.click.value));
      capture.clickHash = Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
    }
    if (text && !capture) attributes[attribute] = '';
    else attributes[attribute] = capture && cart.itemCount > 0 ? text : '';
    journal = appendCapture(journal, capture, cart, context, now);
    const summary = cart.itemCount > 0 ? formatSummary(journal) : '';
    attributes[JOURNAL_ATTRIBUTE] = journal && cart.itemCount > 0 ? JSON.stringify(journal) : '';
    attributes[SUMMARY_ATTRIBUTE] = summary;
    if (journal) env.localStorage.setItem(JOURNAL_ATTRIBUTE, JSON.stringify(journal));
    else remove(env, JOURNAL_ATTRIBUTE);
    if (!captureAllowed(readPrivacy(env), config)) { await clearAll(); return; }
    await post(attributes);
    if (!captureAllowed(readPrivacy(env), config)) { await clearAll(); return; }
    let after;
    try { after = await cartIdentity(env, request); }
    catch { await clearAll(); return; }
    if (!captureAllowed(readPrivacy(env), config) || after.binding !== cart.binding ||
        (cart.itemCount > 0 && after.itemCount === 0)) await clearAll();
  }
  return {
    async write(text, context = {}) {
      if (config.enabled !== true || config.policyReviewed !== true || config.approvedStorefrontCapture !== true ||
          env.location?.protocol !== 'https:' || !['ipshealth.co.za', 'www.ipshealth.co.za'].includes(env.location?.hostname)) {
        throw new Error('capture_not_approved');
      }
      if (typeof text !== 'string') throw new Error('unexpected_cart_fields');
      if (typeof env.navigator?.locks?.request !== 'function') throw new Error('coordination_unavailable');
      const abort = new env.AbortController();
      const timer = env.setTimeout(() => abort.abort(), 3000);
      try {
        return await env.navigator.locks.request(WRITE_LOCK_NAME, { mode: 'exclusive', signal: abort.signal }, async lock => {
          env.clearTimeout(timer);
          if (!lock || lock.name !== WRITE_LOCK_NAME || lock.mode !== 'exclusive') throw new Error('coordination_unavailable');
          await work(text, context);
        });
      } finally { env.clearTimeout(timer); }
    }
  };
}

Object.assign(exports, { WRITE_LOCK_NAME, createCaptureSummaryWriter });

},
"meta/capture.mjs": function (exports, load) {
// Arqum 2026-10-16.
const ATTRIBUTE = '__ips_meta_ad_capture_v1';
const SHOP = 'wdpa1m-fi.myshopify.com';
const MAX_AGE = 30 * 24 * 60 * 60 * 1000;
const HOSTS = new Set(['ipshealth.co.za', 'www.ipshealth.co.za']);
const META_SOURCES = new Set(['fb', 'facebook', 'ig', 'instagram', 'meta', 'an', 'audience_network', 'msg', 'messenger', 'th', 'threads']);
const PAID_MEDIA = new Set(['paid_social', 'paid-social', 'paidsocial', 'paid', 'cpc', 'ppc']);
const GOOGLE_KEYS = ['gclid', 'gbraid', 'wbraid'];
const numeric = value => typeof value === 'string' && /^[1-9]\d{0,22}$/.test(value);

function emptyState() {
  return { version: 1, shop: SHOP, touch: null, cartBinding: null, cartHadItems: false };
}

function captureAllowed(privacy, policy = {}) {
  const regionalReviewed = policy.regionalProcessingReviewed === true &&
    typeof policy.regionalPolicyReviewReference === 'string' &&
    policy.regionalPolicyReviewReference.trim().length >= 8;
  return privacy?.marketingAllowed === true && privacy?.saleOfDataAllowed === true &&
    (privacy?.marketingChoice === 'yes' || (regionalReviewed && privacy?.marketingChoice === '')) &&
    ['', 'yes'].includes(privacy?.saleChoice);
}

function cleanAd(ad) {
  if (ad?.platform !== 'Meta' || !numeric(ad.adId) || !numeric(ad.campaignId) || !numeric(ad.adsetId)) return null;
  return { platform: 'Meta', adId: ad.adId, campaignId: ad.campaignId, adsetId: ad.adsetId };
}

function adFromQuery(search) {
  if (typeof search !== 'string' || search.length > 8192) return null;
  const params = new URLSearchParams(search);
  if (GOOGLE_KEYS.some(key => params.has(key))) return null;
  const sources = params.getAll('utm_source');
  const media = params.getAll('utm_medium');
  const source = sources.length === 1 ? sources[0].trim().toLowerCase() : '';
  const medium = media.length === 1 ? media[0].trim().toLowerCase() : '';
  const hasIds = ['ips_ad_id', 'ad_id', 'adid', 'utm_content', 'ips_campaign_id', 'campaign_id', 'utm_id', 'ips_adset_id', 'adset_id', 'utm_term'].some(key => params.has(key));
  if (!META_SOURCES.has(source) || !PAID_MEDIA.has(medium)) {
    if (sources.length > 1 || media.length > 1 || (['google', 'google ads'].includes(source) && PAID_MEDIA.has(medium)) || (META_SOURCES.has(source) && hasIds)) return null;
    return undefined;
  }
  function identifier(names) {
    if (names.some(name => params.getAll(name).length > 1)) return null;
    const values = names.flatMap(name => params.getAll(name));
    if (!values.length || values.some(value => !numeric(value)) || new Set(values).size !== 1) return null;
    return values[0];
  }
  const ad = { platform: 'Meta',
    adId: identifier(['ips_ad_id', 'ad_id', 'adid', 'utm_content']),
    campaignId: identifier(['ips_campaign_id', 'campaign_id', 'utm_id']),
    adsetId: identifier(['ips_adset_id', 'adset_id', 'utm_term']) };
  return cleanAd(ad);
}

function cleanTouch(touch, now) {
  const ad = cleanAd(touch?.ad);
  if (!ad || touch?.shop !== SHOP || typeof touch.captureId !== 'string' ||
      !/^[a-zA-Z0-9_-]{1,80}$/.test(touch.captureId) || !Number.isFinite(touch.capturedAt) ||
      typeof touch.qa !== 'boolean' || touch.capturedAt > now || now - touch.capturedAt >= MAX_AGE) return null;
  return { shop: SHOP, captureId: touch.captureId, capturedAt: touch.capturedAt, ad, qa: touch.qa };
}

function sameAd(a, b) {
  return a && b && a.platform === b.platform && a.adId === b.adId && a.campaignId === b.campaignId && a.adsetId === b.adsetId;
}

function planCapture(previous, event, config = {}) {
  const result = { state: emptyState(), attributes: null, reason: 'disabled', exportReady: false };
  if (config.enabled !== true || config.policyReviewed !== true) return result;
  if (!HOSTS.has(event?.host)) return { ...result, reason: 'unsupported_host' };
  if (!Number.isFinite(event?.now)) return { ...result, reason: 'invalid_time' };

  const clear = { [ATTRIBUTE]: '' };
  if (!captureAllowed(event.privacy, config)) return { ...result, attributes: clear, reason: 'consent_not_verified' };
  if (!Number.isInteger(event.cart?.itemCount) || event.cart.itemCount < 0 ||
      typeof event.cart.binding !== 'string' || !/^[a-f0-9]{64}$/.test(event.cart.binding)) {
    return { ...result, attributes: clear, reason: 'cart_identity_unknown' };
  }

  const validPrevious = previous?.version === 1 && previous.shop === SHOP &&
    typeof previous.cartHadItems === 'boolean' &&
    ((previous.touch === null && previous.cartBinding === null) ||
      (typeof previous.cartBinding === 'string' && /^[a-f0-9]{64}$/.test(previous.cartBinding)));
  const hasStoredTouch = previous?.touch !== null && previous?.touch !== undefined;
  if (hasStoredTouch && (!validPrevious || typeof previous.touch !== 'object' ||
      typeof previous.touch.qa !== 'boolean' || !cleanAd(previous.touch.ad))) {
    return { ...result, attributes: clear, reason: 'stored_capture_invalid' };
  }
  const old = validPrevious ? previous : emptyState();
  let touch = cleanTouch(old.touch, event.now);
  const changedCart = old.cartBinding && old.cartBinding !== event.cart.binding;
  const emptiedCart = old.cartHadItems === true && event.cart.itemCount === 0;
  if (changedCart || emptiedCart || event.kind === 'cart_cleared') touch = null;

  const canReadArrival = event.kind === 'landing' && event.navigationType === 'navigate' && event.freshArrival === true;
  const incoming = canReadArrival ? adFromQuery(event.search) : undefined;
  if (incoming === null) return { ...result, attributes: clear, reason: 'invalid_meta_ad_parameters' };
  if (incoming && !sameAd(incoming, touch?.ad)) {
    if (typeof event.captureId !== 'string' || !/^[a-zA-Z0-9_-]{1,80}$/.test(event.captureId)) {
      return { ...result, attributes: clear, reason: 'capture_identity_unknown' };
    }
    touch = { shop: SHOP, captureId: event.captureId, capturedAt: event.now, ad: incoming, qa: config.qaMode === true };
  }

  const state = { version: 1, shop: SHOP, touch, cartBinding: event.cart.binding,
    cartHadItems: event.cart.itemCount > 0 };
  if (event.kind === 'accelerated_checkout') {
    return { ...result, state: { ...state, touch: null }, attributes: clear, reason: 'accelerated_checkout_not_verified' };
  }
  if (!touch) return { ...result, state, attributes: clear,
    reason: changedCart || emptiedCart ? 'old_cart_capture_removed' : 'no_valid_meta_ad' };
  if (event.cart.itemCount === 0) {
    return { ...result, state, attributes: clear, reason: 'consented_meta_ad_pending_cart' };
  }

  const envelope = { version: 1, ...touch, cartBinding: event.cart.binding,
    consentObservedAt: event.now,
    permissionBasis: event.privacy.marketingChoice === 'yes' ? 'explicit_marketing_choice' : 'shopify_processing_permissions',
    regionalPolicyReviewReference: event.privacy.marketingChoice === '' ? config.regionalPolicyReviewReference : null,
    consent: { marketingAllowed: true, saleOfDataAllowed: true,
      marketingChoice: event.privacy.marketingChoice, saleChoice: event.privacy.saleChoice },
    source: 'client_meta_ad_capture_candidate', qa: touch.qa, exportReady: false };
  return { ...result, state, attributes: { [ATTRIBUTE]: JSON.stringify(envelope) },
    reason: 'candidate_requires_native_order_and_consent_verification' };
}

function createController(io, config = {}) {
  config = Object.freeze({ ...config });
  let state = emptyState();
  let generation = 0;
  let journalArrivalProcessed = false;
  let arrivalProcessed = false;
  let queue = Promise.resolve();
  let status = { reason: 'disabled', storageUpdated: false, cartWriteResponseReceived: false, exportReady: false };

  return {
    hydrate(saved) {
      state = saved?.version === 1 && saved.shop === SHOP ? saved : emptyState();
    },
    dispatch(event) {
      const journalContext = { kind: event.kind, freshArrival: event.kind === 'landing' && event.navigationType === 'navigate' &&
        event.freshArrival === true && !journalArrivalProcessed, now: event.now, captureId: event.captureId, search: event.search };
      if (event.kind === 'landing' || event.kind === 'refresh') journalArrivalProcessed = true;
      const freshArrival = event.kind === 'landing' && event.navigationType === 'navigate' && event.freshArrival === true && !arrivalProcessed;
      if (event.kind === 'landing' || event.kind === 'refresh') arrivalProcessed = true;
      const plan = planCapture(state, { ...event, freshArrival }, config);
      state = plan.state;
      const revision = ++generation;
      status = { reason: plan.reason, storageUpdated: false, cartWriteResponseReceived: false, exportReady: false };
      if (!plan.attributes) return Promise.resolve({ ...status });
      let stored = plan.state.touch ? structuredClone(plan.state) : null;
      const attributes = structuredClone(plan.attributes);
      queue = queue.then(async () => {
        if (revision !== generation) return { superseded: true, exportReady: false };
        let storageUpdated = false;
        let cartWriteResponseReceived = false;
        let reason = plan.reason;
        const freshAllowed = async () => {
          try { return captureAllowed(await io.readPrivacy(), config); } catch { return false; }
        };
        const revoke = async () => {
          stored = null;
          attributes[ATTRIBUTE] = '';
          reason = 'consent_changed_before_capture_write';
          if (revision === generation) state = emptyState();
          try { await io.writeStored(null); storageUpdated = true; } catch { storageUpdated = false; }
        };
        if (stored && !(await freshAllowed())) {
          stored = null;
          attributes[ATTRIBUTE] = '';
          reason = 'consent_changed_before_capture_write';
          if (revision === generation) state = emptyState();
        }
        try { await io.writeStored(stored); storageUpdated = true; } catch {}
        if (attributes[ATTRIBUTE] && !(await freshAllowed())) await revoke();
        try { await io.writeAttributes(attributes, journalContext); cartWriteResponseReceived = true; } catch {}
        if (revision === generation && attributes[ATTRIBUTE] && !(await freshAllowed())) {
          await revoke();
          try { await io.writeAttributes(attributes, journalContext); cartWriteResponseReceived = true; }
          catch { cartWriteResponseReceived = false; }
        }
        if (revision !== generation) return { superseded: true, exportReady: false };
        status = { reason: storageUpdated && cartWriteResponseReceived ? reason : 'capture_io_failed',
          storageUpdated, cartWriteResponseReceived, exportReady: false };
        return { ...status };
      }).catch(() => {
        if (revision === generation) status = { reason: 'capture_io_failed', storageUpdated: false,
          cartWriteResponseReceived: false, exportReady: false };
        return { ...status };
      });
      return queue;
    },
    inspect() {
      return { ...status, hasCandidate: Boolean(state.touch), hasCartBinding: Boolean(state.cartBinding),
        cartHadItems: state.cartHadItems, generation };
    },
    snapshotForConsentedStorage() {
      return state.touch ? structuredClone(state) : null;
    },
    settled() { return queue; }
  };
}

Object.assign(exports, { ATTRIBUTE, SHOP, emptyState, captureAllowed, planCapture, createController });

},
"meta/coordination.mjs": function (exports, load) {
// Arqum 2026-10-16.
const { SHOP } = load('meta/capture.mjs');
const LOCK_NAME = `ips-ad-capture-summary:${SHOP}:v1`;

function createCoordination(env) {
  const waiting = new Set();
  let disposed = false;
  const supported = typeof env.navigator?.locks?.request === 'function' &&
    typeof env.AbortController === 'function';

  return {
    supported,
    async run(work) {
      if (disposed) return { reason: 'disposed', exportReady: false };
      if (!supported) return { reason: 'coordination_unavailable', exportReady: false };
      const abort = new env.AbortController();
      waiting.add(abort);
      const timer = env.setTimeout(() => abort.abort(), 3000);
      try {
        return await env.navigator.locks.request(LOCK_NAME, { mode: 'exclusive', signal: abort.signal }, async lock => {
          env.clearTimeout(timer);
          waiting.delete(abort);
          if (disposed) return { reason: 'disposed', exportReady: false };
          if (!lock || lock.name !== LOCK_NAME || lock.mode !== 'exclusive') {
            return { reason: 'coordination_unavailable', exportReady: false };
          }
          return await work();
        });
      } catch {
        return { reason: disposed ? 'disposed' : 'coordination_failed', exportReady: false };
      } finally {
        env.clearTimeout(timer);
        waiting.delete(abort);
      }
    },
    dispose() {
      disposed = true;
      for (const abort of waiting) abort.abort();
      waiting.clear();
    }
  };
}

Object.assign(exports, { LOCK_NAME, createCoordination });

},
"meta/shopify-adapter.mjs": function (exports, load) {
// Arqum 2026-10-16.
const { ATTRIBUTE, SHOP, captureAllowed, createController } = load('meta/capture.mjs');
const { createCoordination } = load('meta/coordination.mjs');
const { createCaptureSummaryWriter } = load('summary-writer.mjs');
function approved(env, config) {
  return config.enabled === true && config.policyReviewed === true &&
    config.approvedStorefrontCapture === true && env.location?.protocol === 'https:' &&
    ['ipshealth.co.za', 'www.ipshealth.co.za'].includes(env.location?.hostname);
}

function readPrivacy(env) {
  try {
    const api = env.Shopify.customerPrivacy;
    const choices = api.currentVisitorConsent();
    return { marketingAllowed: api.marketingAllowed() === true,
      saleOfDataAllowed: api.saleOfDataAllowed() === true,
      marketingChoice: choices.marketing, saleChoice: choices.sale_of_data };
  } catch { return {}; }
}

function createShopifyAdapters(env, config = {}) {
  config = Object.freeze({ ...config });
  function guard() { if (!approved(env, config)) throw new Error('capture_not_approved'); }
  function endpoint(path) {
    guard();
    const root = env.Shopify?.routes?.root;
    if (typeof root !== 'string' || !/^\/(?:[A-Za-z0-9_-]+\/)*$/.test(root)) {
      throw new Error('invalid_locale_route');
    }
    const url = new URL(root + path, env.location.origin);
    if (url.origin !== env.location.origin) throw new Error('unexpected_cart_origin');
    return url.href;
  }
  async function request(path, options = {}, parseJson = false) {
    const url = endpoint(path);
    const abort = new env.AbortController();
    let timer;
    const timeout = new Promise((_, reject) => {
      timer = env.setTimeout(() => { abort.abort(); reject(new Error('cart_request_timeout')); }, 5000);
    });
    try {
      return await Promise.race([timeout, (async () => {
        const response = await env.fetch(url, { credentials: 'same-origin', mode: 'same-origin',
          redirect: 'error', ...options, signal: abort.signal });
        if (!response.ok) throw new Error('cart_request_failed');
        return parseJson ? await response.json() : undefined;
      })()]);
    } finally { env.clearTimeout(timer); }
  }

  const summaryWriter = createCaptureSummaryWriter(env, config, ATTRIBUTE, request);
  return {
    readPrivacy: async () => { guard(); return readPrivacy(env); },
    async loadPrivacy() {
      guard();
      if (env.Shopify?.customerPrivacy) return true;
      if (typeof env.Shopify?.loadFeatures !== 'function') return false;
      return new Promise(resolve => {
        let finished = false;
        const timeout = env.setTimeout(() => { finished = true; resolve(false); }, 3000);
        try {
          env.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
            if (finished) return;
            finished = true;
            env.clearTimeout(timeout);
            resolve(!error && Boolean(env.Shopify.customerPrivacy));
          });
        } catch { env.clearTimeout(timeout); resolve(false); }
      });
    },
    readStored() {
      guard();
      try {
        const privacy = readPrivacy(env);
        if (!captureAllowed(privacy, config)) return null;
        const text = env.localStorage.getItem(ATTRIBUTE);
        if (!text || text.length > 4096) return null;
        return JSON.parse(text);
      } catch { return null; }
    },
    async writeStored(value) {
      guard();
      if (value === null) env.localStorage.removeItem(ATTRIBUTE);
      else env.localStorage.setItem(ATTRIBUTE, JSON.stringify(value));
    },
    async readCart() {
      const raw = await request('cart.js', {}, true);
      if (!Number.isInteger(raw.item_count) || raw.item_count < 0 || typeof raw.token !== 'string' ||
          !raw.token.length || raw.token.length > 2048) throw new Error('cart_identity_unknown');
      const bytes = new TextEncoder().encode(SHOP + ':' + raw.token);
      const digest = await env.crypto.subtle.digest('SHA-256', bytes);
      const binding = Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
      return { itemCount: raw.item_count, binding };
    },
    async writeAttributes(attributes, context = {}) {
      guard();
      if (Object.keys(attributes).length !== 1 || typeof attributes[ATTRIBUTE] !== 'string') {
        throw new Error('unexpected_cart_fields');
      }
      await summaryWriter.write(attributes[ATTRIBUTE], context);
    }
  };
}

function createShopifyRuntime(env, config = {}) {
  config = Object.freeze({ ...config });
  if (!approved(env, config)) return { status: 'disabled', start: async () => ({ reason: 'disabled' }) };
  const coordination = createCoordination(env);
  if (!coordination.supported) {
    return { status: 'local_prototype_not_released',
      start: async () => ({ reason: 'coordination_unavailable', exportReady: false }) };
  }
  const io = createShopifyAdapters(env, config);
  const controller = createController(io, config);
  let listener;
  let unsubscribe;
  let startPromise;
  let disposed = false;

  async function handle(kind, navigationType) {
    if (disposed) return { reason: 'disposed', exportReady: false };
    return coordination.run(async () => {
      // Re-read state inside the shared origin lock.
      controller.hydrate(io.readStored());
      let privacy;
      let cart;
      try {
        privacy = await io.readPrivacy();
        if (captureAllowed(privacy, config)) cart = await io.readCart();
      } catch {
        cart = null;
      }
      if (disposed) return { reason: 'disposed', exportReady: false };
      return controller.dispatch({ kind, navigationType, host: env.location.hostname,
        freshArrival: kind === 'landing' && navigationType === 'navigate',
        now: Date.now(), search: env.location.search, captureId: env.crypto.randomUUID(), privacy, cart });
    });
  }

  return {
    status: 'local_prototype_not_released',
    start() {
      if (disposed) return Promise.resolve({ reason: 'disposed', exportReady: false });
      if (startPromise) return startPromise;
      startPromise = (async () => {
        await io.loadPrivacy();
        if (disposed) return { reason: 'disposed', exportReady: false };
        listener = () => { void handle('consent_changed', 'navigate').then(result => {
          if (typeof config.onResult === 'function') config.onResult(result);
        }).catch(() => {}); };
        env.document.addEventListener('visitorConsentCollected', listener);
        if (typeof config.subscribeCart === 'function') {
          unsubscribe = config.subscribeCart(() => handle('cart_changed', 'navigate'));
        }
        const navigationType = env.performance?.getEntriesByType('navigation')?.[0]?.type;
        return handle(navigationType === 'reload' ? 'refresh' : 'landing', navigationType);
      })();
      return startPromise;
    },
    cartChanged: () => handle('cart_changed', 'navigate'),
    cartCleared: () => handle('cart_cleared', 'navigate'),
    acceleratedCheckout: () => handle('accelerated_checkout', 'navigate'),
    inspect: () => controller.inspect(),
    dispose() {
      disposed = true;
      coordination.dispose();
      if (listener) env.document.removeEventListener('visitorConsentCollected', listener);
      if (typeof unsubscribe === 'function') unsubscribe();
    }
  };
}

Object.assign(exports, { readPrivacy, createShopifyAdapters, createShopifyRuntime });

},
"meta/storefront-entry.js": function (exports, load) {
const { ATTRIBUTE } = load('meta/capture.mjs');
const { createShopifyRuntime } = load('meta/shopify-adapter.mjs');
// Arqum 2026-10-16.
(function initialiseMetaOrderCapture() {
  const release = Object.freeze({ enabled: true, policyReviewed: true,
    approvedStorefrontCapture: true, regionalProcessingReviewed: true,
    regionalPolicyReviewReference: 'meta-order-link-native-permissions-20261015', qaMode: false });
  if (!release.enabled) return;
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  const runtime = createShopifyRuntime(window, { ...release,
    subscribeCart(callback) {
      return subscribe(PUB_SUB_EVENTS.cartUpdate, () => { void callback().catch(() => {}); });
    } });
  const recheck = () => { if (typeof runtime.cartChanged === 'function') void runtime.cartChanged().catch(() => {}); };
  window.addEventListener('storage', event => { if (event.key === ATTRIBUTE) recheck(); });
  window.addEventListener('pageshow', event => { if (event.persisted) recheck(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') recheck(); });
  document.addEventListener('click', event => {
    if (event.target.closest?.('.shopify-payment-button,shopify-accelerated-checkout') && typeof runtime.acceleratedCheckout === 'function') {
      void runtime.acceleratedCheckout().catch(() => {});
    }
  }, true);
  void runtime.start().catch(() => {});
})();

}
};
const cache = Object.create(null);
function load(name) { if (!cache[name]) { const value = {}; cache[name] = value; modules[name](value, load); } return cache[name]; }
load('meta/storefront-entry.js');
})();
